var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1035 4.2258C18.6353 3.75739 18.0794 3.38581 17.4676 3.13229C16.8557 2.87878 16.1999 2.74829 15.5377 2.74829C14.8754 2.74829 14.2196 2.87878 13.6077 3.13229C12.9959 3.38581 12.44 3.75739 11.9718 4.2258L11.0002 5.19746L10.0285 4.2258C9.08277 3.28008 7.8001 2.74878 6.46265 2.74878C5.1252 2.74878 3.84253 3.28008 2.89682 4.2258C1.9511 5.17152 1.4198 6.45418 1.4198 7.79163C1.4198 9.12908 1.9511 10.4117 2.89682 11.3575L3.86848 12.3291L11.0002 19.4608L18.1318 12.3291L19.1035 11.3575C19.5719 10.8893 19.9435 10.3334 20.197 9.72154C20.4505 9.1097 20.581 8.45391 20.581 7.79163C20.581 7.12935 20.4505 6.47356 20.197 5.86172C19.9435 5.24988 19.5719 4.69399 19.1035 4.2258V4.2258Z",
    stroke: "#00B1CC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon_heart.da0b581d1654e64b01b055da15b29461.svg";
export { ForwardRef as ReactComponent };